import { Field } from 'formik'

import TextBox from 'components/TextBox'

import { createRequiredLabel } from 'utils/formik'

const Info = ({ menuIndex, showValidationErrors }) => {
  return (
    <>
      <h3 className="header-title">Info</h3>
      <div className="item-details">
        <div className="content-wrapper">
          <Field
            component={TextBox}
            label={createRequiredLabel('Internal Name')}
            name={`menus.${menuIndex}.name`}
            showValidationErrors={showValidationErrors}
            required={false}
          />
        </div>
        <div className="text-field">
          <Field
            component={TextBox}
            label="Display Name"
            name={`menus.${menuIndex}.displayName`}
            showValidationErrors={showValidationErrors}
            required={false}
          />
        </div>
      </div>
    </>
  )
}

export default Info
